import { isClerkAPIResponseError } from '@clerk/nextjs/errors'
import { ClerkAPIError, ClerkAPIResponseError } from '@clerk/nextjs/types'

type IMakeHandleClerkErrorArgs = {
    shouldRethrow?: boolean
    onAllErrors?: (errors: ClerkAPIError[]) => void
}

export const makeHandleClerkError =
    ({ shouldRethrow = true, onAllErrors }: IMakeHandleClerkErrorArgs = {}) =>
    (error: any) => {
        const isClerkError = isClerkAPIResponseError(error)

        if (!isClerkError) return

        const typecastedError = error as ClerkAPIResponseError

        if (!typecastedError.clerkError) return

        const firstError = typecastedError.errors[0]

        if (!firstError) return

        onAllErrors?.(typecastedError.errors)

        if (shouldRethrow) {
            throw error
        }
    }
